import src from "IMAGE";
export default { src, width: 324, height: 324, blurWidth: 0, blurHeight: 0};
